import React from "react";
import ReactDOM from "react-dom/client";
import axe from "@axe-core/react";
import "./index.css";
import App from "./App";
import ReactGA from "react-ga";
import { HashRouter } from "react-router-dom";

// Initialize GA with debug mode in development
ReactGA.initialize("G-KDTNPWJPGR", {
  debug: process.env.NODE_ENV === "development",
  gaOptions: {
    siteSpeedSampleRate: 100,
  },
});

// Track initial page view
ReactGA.pageview(window.location.pathname + window.location.search);

// Track hash changes for HashRouter
const trackHashChanges = () => {
  ReactGA.pageview(window.location.hash);
};

window.addEventListener("hashchange", trackHashChanges);

if (process.env.NODE_ENV !== "production") {
  axe(React, ReactDOM, 1000);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
);
